import { dynamicGroupSchema } from "@redotech/redo-customer-segments-common/customers/customer-group-definition";
import { segmentSchema } from "@redotech/redo-customer-segments-common/marketing/segments/segment-zod-schema";
import * as z from "zod";

export const updateDynamicSegment = {
  name: "updateDynamicSegment" as const,
  input: z.object({
    _id: z.string(),
    name: z.string().optional(),
    conditions: segmentSchema.optional(),
  }),
  output: dynamicGroupSchema,
};
